<template>
  <section id="about" class="container my-5">

    <div class="text-center mb-5">
      <h2 class="position-relative d-inline-block">
        <span class="px-2">ABOUT US</span>
      </h2>
    </div>

    <div class="row align-items-center">
      <div class="col-md-4 mb-md-0 mb-4">
        <h5 class="text-uppercase text-muted">About our business</h5>
        <h3 class="fw-bold">DISCOVER Beeston's BEST</h3>
<p class="text-muted">
  Welcome to CCF Carefully Crafted Fibreglass! Est. 2003
</p>

        <a href="https://app.orderopia.com/ccf-fibreglass/order" class="sticker-btn mt-2">Discover Our Prodcuts</a>
      </div>

      <!-- Image Column 1 -->
      <div class="col-md-4 mb-md-0 mb-4">
        <img
          src="../../assets/img/about-1.webp"
          class="img-fluid rounded"
          alt="Our Restaurant Story"
        />
        <h5 class="mt-3 fw-semibold">My Story</h5>
        <p class="small text-muted">
            
I earned a GCSE in plastic and GRP fibreglass, then spent 22 years at a GRP company, progressing from bench hand to manager. I led the GRP division for several years until the owner’s passing led to my redundancy and I started CCF Fibreglass.
        </p>
      </div>

      <!-- Image Column 2 -->
      <div class="col-md-4 mb-md-0 mb-4">
        <img
          src="../../assets/img/about-2.webp"
          class="img-fluid rounded"
          alt="Master Chefs"
        />
<h5 class="mt-3 fw-semibold">Family Business</h5>
<p class="small text-muted">My son joined me to complete CCF as a family run business
  We have worked, and will continue to work, for major national corporations, large and small businesses and for individuals so if you have a project which may benefit from our expertise please contact us. 
</p>


      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutUs'
}
</script>

<style scoped>

section {
    max-width:1000px;
}

img {
    height:200px;
    width:100%;
    object-fit: cover;
}
.sticker-btn {
  position: relative;
  color: white;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  background-color: transparent;
  background-image: url('@/assets/img/sticker-btn.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
  width: 300px; /* Match the actual size of your image */
  height: 50px; /* Adjust to match image */
  /* Shape clipping using mask */
  -webkit-mask-image: url('@/assets/img/sticker-btn.webp');
  mask-image: url('@/assets/img/sticker-btn.webp');
  -webkit-mask-size: cover;
  mask-size: cover;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
}
.sticker-btn:hover {
  transform: scale(1.03) rotate(-2deg);
}



</style>
